import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AlertApiModel, AlertsSelectorsApiModel } from '@app/api/api-models';
import { CrudService } from '@app/api/api-services/crud.service';

@Injectable()
export class AlertsService extends CrudService<AlertApiModel, string> {
  public readonly apiUrl = 'alerts';

  public getList(): Observable<AlertApiModel[]> {
    return super.getList().pipe(map((array) => array.map((x) => new AlertApiModel().deserialize(x))));
  }

  public add(model: AlertApiModel): Observable<AlertApiModel> {
    return super.add(model).pipe(map((x) => new AlertApiModel().deserialize(x)));
  }

  public update(model: AlertApiModel): Observable<AlertApiModel> {
    return super.update(model).pipe(map((x) => new AlertApiModel().deserialize(x)));
  }

  public getSelectors(): Observable<AlertsSelectorsApiModel> {
    return this.http
      .get<AlertsSelectorsApiModel>(`${this.apiUrl}/selectors`)
      .pipe(map((x) => new AlertsSelectorsApiModel().deserialize(x)));
  }
}
